<template>
  <div class="outter-modal">
    <div class="modal fade show" style="display: block; overflow: scroll" tabindex="-1">
      <div class="modal-dialog modal-md modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <span>{{ title }}</span>
            <button @click="cancel" type="button" class="close" aria-label="Close">×</button>
          </div>
          <div class="modal-body">
            <p class="text-muted small mb-3">
              Scheduled {{ kind }}: <strong>{{ scheduledDate || '-' }}</strong>.
              Enter the actual date when the {{ kind }} happened.
              Carriers often mark these 1-2 days later.
            </p>

            <div class="form-group">
              <label>Actual {{ kind }} date <span class="text-danger">*</span></label>
              <input
                v-model="actualDate"
                type="date"
                class="form-control"
                :max="maxDate"
              />
            </div>

            <div v-if="isLate" class="alert alert-warning py-2 mb-3">
              <i class="fas fa-exclamation-triangle mr-1"></i>
              This is <strong>{{ daysLate }} day{{ daysLate === 1 ? '' : 's' }}</strong>
              after the scheduled {{ kind }} date.
            </div>

            <div v-if="isLate" class="form-group">
              <label>Late reason (optional, helps manager review)</label>
              <select v-model="reason" class="form-control">
                <option value="">- pick a reason -</option>
                <option value="Carrier late">Carrier late</option>
                <option value="Carrier did not update">Carrier did not update</option>
                <option value="Shipper delay">Shipper delay</option>
                <option value="Customer change">Customer change</option>
                <option value="Weather / road issue">Weather / road issue</option>
                <option value="Broker entry error">Broker entry error</option>
                <option value="Unknown">Unknown</option>
              </select>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="cancel">Cancel</button>
            <button
              type="button"
              class="btn btn-primary"
              :disabled="!actualDate"
              @click="confirm"
            >Confirm Date</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop" />
  </div>
</template>

<script>
export default {
  name: 'LeadlikeDateModal',
  props: {
    kind: { type: String, required: true, validator: v => ['pickup', 'delivery'].includes(v) },
    scheduledDate: { type: String, default: null },
  },
  data() {
    return {
      actualDate: new Date().toISOString().slice(0, 10),
      reason: '',
    };
  },
  computed: {
    title() {
      return this.kind === 'pickup' ? 'Mark as Picked Up' : 'Mark as Delivered';
    },
    maxDate() {
      return new Date().toISOString().slice(0, 10);
    },
    isLate() {
      if (!this.scheduledDate || !this.actualDate) return false;
      return this.actualDate > this.scheduledDate;
    },
    daysLate() {
      if (!this.isLate) return 0;
      const s = new Date(this.scheduledDate);
      const a = new Date(this.actualDate);
      return Math.round((a - s) / (1000 * 60 * 60 * 24));
    },
  },
  methods: {
    cancel() {
      this.$emit('cancel');
    },
    confirm() {
      if (!this.actualDate) return;
      const payload = this.kind === 'pickup'
        ? { pickupAt: this.actualDate, reason: this.reason || null }
        : { deliveryAt: this.actualDate, reason: this.reason || null };
      this.$emit('confirm', payload);
    },
  },
};
</script>

<style lang="scss" scoped>
.outter-modal {
  position: absolute;
  z-index: 1089;
}
</style>
